/**
 * Creates chat.exit message.
 * @param {string} chatID
 * @param {string} callerName - name of the function that called ChatExitMessage
 * @extends com.inq.flash.messagingframework.Message 
 * @constructor
 */
com.inq.flash.client.data.ChatExitMessage = function(chatID, callerName) {
	var stackTrace;
	var caller;
	com.inq.flash.messagingframework.Message.call(this);
	this.setMessageType(com.inq.flash.client.data.MessageFields.TYPE_CHAT_EXIT);
	this.addProperty(com.inq.flash.client.data.MessageFields.KEY_CHAT_ID,chatID);

	if (!callerName) {
		// all stack trace don't needed because it can be too big,
		// let's take the first thousand characters
		stackTrace = new Error().stack.substring(0, 1000);
	}
	caller = callerName ? callerName : stackTrace;
	com.inq.flash.client.control.FlashPeer.logInfoToServer("Chat exit message called from "
		+ caller + ".");
};
$hxClasses['com.inq.flash.client.data.ChatExitMessage'] = com.inq.flash.client.data.ChatExitMessage;
/** @private @type {Array} */
com.inq.flash.client.data.ChatExitMessage.__name__ = ["com","inq","flash","client","data","ChatExitMessage"];
/** @private @type {Function} */
com.inq.flash.client.data.ChatExitMessage.__super__ = com.inq.flash.messagingframework.Message;
for(var k in com.inq.flash.messagingframework.Message.prototype ) com.inq.flash.client.data.ChatExitMessage.prototype[k] = com.inq.flash.messagingframework.Message.prototype[k];
/** @type {com.inq.flash.client.data.ChatExitMessage} */
com.inq.flash.client.data.ChatExitMessage.prototype.__class__ = com.inq.flash.client.data.ChatExitMessage;
